export enum SimType {
  INBOUND = "inbound",
  OUTBOUND = "outbound",
}

export class SimLookupResponseEntity {
  simType?: SimType;
  iccid?: string;
  status?: string | number;
  packageName?: string;
  totalData?: string;
  usedData?: string;
  totalDataDaily?: string;
  remainingData?: string;
  activationExpireDate?: string;
  activatedAt?: string;
  planExpireDate?: string;

  constructor(data?: Partial<SimLookupResponseEntity>) {
    Object.assign(this, data);
  }
}
